import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "@/Models/Lines/DimensionLine";

export class SlopedRectangleFlipHorizontal extends AbstractShape {
	constructor( dimensions?: object ) {
		super( 'sloped-rectangle-flip-horizontal', dimensions );
	}

	getLength(): Length {
		return this.cleanedPrimitives.height_left;
	}

	getHeightLeft(): Length {
		return this.getLength();
	}SlopedRectangle;

	getRightLength(): Length {
		return this.cleanedPrimitives.height_right;
	}

	getHeightRight(): Length {
		return this.getRightLength();
	}

	getWidth(): Length {
		return this.cleanedPrimitives.width;
	}

	getHeight(): Length {
		return this.cleanedPrimitives.height_left.max( this.cleanedPrimitives.height_right );
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'height_left', secondary: 'width', tertiary: 'height_right' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		if(focusedElement.includes("cutout_measurement") || forceRender) {
			return [
				new DimensionLine( [this.getWidth().in_mm(), 0], [this.getWidth().in_mm(), this.getRightLength().in_mm() ], this.renderDimensionLabel( 'height_right' ), [40, 0], ratio, this.getDimensionLineType('measurements-sloped-rectangle-height_right', focusedElement, forceRender)),
				new DimensionLine( [0, 0], [0, this.getLength().in_mm()], this.renderDimensionLabel( 'height_left' ), [-40, 0], ratio, this.getDimensionLineType('measurements-sloped-rectangle-height_left', focusedElement, forceRender) ),
				new DimensionLine( [0, 0], [this.getWidth().in_mm(), 0], this.renderDimensionLabel( 'width' ), [0, -40], ratio, this.getDimensionLineType('measurements-sloped-rectangle-width', focusedElement, forceRender) ),
			];
		}

		return [];
	}

	getDefaultDimensions(): Dimensions {
		return {
			height_left: 25,
			height_right: 50,
			width: 50,
		};
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();
		const height = enclosingRectangle.height();

		return {
			height_left: height.divide(3).in_cm(),
			height_right:height.divide(2).in_cm(),
			width: width.divide(2).in_cm(),
		};
	}
}
